import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {L10nModule} from '../../../components/translate';
import {OnboardingMenuItemComponent} from './onboarding-menu-item.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule
    ],
    declarations: [
        OnboardingMenuItemComponent
    ],
    exports: [
        OnboardingMenuItemComponent
    ]
})
export class OnboardingMenuItemModule {}
